import { AnyAction } from 'redux';
import produce from 'immer';
import { DownloadsActionTypes } from '../actions/downloads';
import { DownloadsState } from '../types/state';

const initialState: DownloadsState = {
  payloadID: null,
  isLoading: false,
  isFileRequested: false,
  isFileFetched: false,
  isOpen: false,
  isSendOnEmail: false,
  sendTo: '',
  isOpenFileRequested: false,
  downloadURL: null,
  requestID: null,
  fileList: null,
  isFileDownloaded: true,
};

const downloads = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case DownloadsActionTypes.IS_LOADING: {
      return produce(state, (df) => {
        df.isLoading = action.payload;
      });
    }

    case DownloadsActionTypes.FILES_FETCHED: {
      return produce(state, (df) => {
        df.fileList = action.payload;
      });
    }

    case DownloadsActionTypes.FILE_DOWNLOADED: {
      return produce(state, (df) => {
        df.downloadURL = null;
        df.isFileDownloaded = true;
        df.isLoading = false;
      });
    }

    case DownloadsActionTypes.REPORT_SENT_AGAIN: {
      return produce(state, (df) => {
        df.isLoading = false;
      });
    }

    case DownloadsActionTypes.REPORT_NOT_SENT_AGAIN: {
      return produce(state, (df) => {
        df.isLoading = false;
      });
    }

    case DownloadsActionTypes.FETCHED_DOWNLOAD_LINK: {
      return produce(state, (df) => {
        df.downloadURL = action.payload;
        df.isFileDownloaded = false;
        df.isLoading = false;
      });
    }
    case DownloadsActionTypes.NOT_FETCHED_DOWNLOAD_LINK: {
      return produce(state, (df) => {
        df.isFileDownloaded = true;
        df.downloadURL = null;
        df.isLoading = false;
      });
    }

    case DownloadsActionTypes.FILE_DELETED: {
      return produce(state, (df) => {
        df.fileList = action.payload;
      });
    }

    case DownloadsActionTypes.FILE_REQUESTED: {
      return produce(state, (df) => {
        df.isFileRequested = true;
        df.isFileFetched = false;
        df.isLoading = true;
        df.isSendOnEmail = action.payload.isSendOnEmail;
        df.sendTo = action.payload.sendTo;
        df.isOpenFileRequested = true;
        df.requestID = action.payload.id;
      });
    }

    case DownloadsActionTypes.TOGGLE_DOWNLOADS: {
      return produce(state, (df) => {
        df.isOpen = !state.isOpen;
        df.isOpenFileRequested = false;
        df.downloadURL = null;
        df.isSendOnEmail = false;
        df.sendTo = '';
      });
    }

    case DownloadsActionTypes.CLOSE_DOWNLOAD_NOTIFICATION: {
      return produce(state, (df) => {
        df.isOpenFileRequested = !state.isOpenFileRequested;
        df.downloadURL = null;
        df.isSendOnEmail = false;
        df.isFileFetched = false;
        df.isFileRequested = false;
        df.sendTo = '';
      });
    }

    case DownloadsActionTypes.FILE_FETCHED: {
      return produce(state, (df) => {
        df.isFileRequested = true;
        df.requestID = null;
        df.isFileFetched = true;
        df.downloadURL = action.payload.downloadURL;
        df.isLoading = false;
      });
    }

    case DownloadsActionTypes.FILE_NOT_FETCHED: {
      return produce(state, (df) => {
        df.downloadURL = null;
      });
    }

    case DownloadsActionTypes.RESET: {
      return produce(state, (df) => {
        df.isFileRequested = false;
        df.isFileFetched = false;
        df.downloadURL = null;
        df.isLoading = false;
        df.isSendOnEmail = false;
        df.sendTo = '';
      });
    }

    default: {
      return state;
    }
  }
};

export default downloads;
